var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal-card",
      staticStyle: { width: "auto", "min-height": "80vh" },
    },
    [
      _vm._m(0),
      _c(
        "section",
        {
          staticClass: "modal-card-body",
          staticStyle: { "background-color": "white" },
        },
        [
          _c(
            "div",
            { staticClass: "mb-5" },
            [
              _c("multiselect", {
                attrs: {
                  placeholder: "Select a reference...",
                  options: _vm.siData,
                  "custom-label": _vm.siWithCustomerId,
                  "track-by": "si",
                  label: "si",
                },
                on: { input: _vm.selectSI },
                model: {
                  value: _vm.selectedSi,
                  callback: function ($$v) {
                    _vm.selectedSi = $$v
                  },
                  expression: "selectedSi",
                },
              }),
            ],
            1
          ),
          _vm.selectedData
            ? _c(
                "div",
                [
                  _c("div", { staticClass: "mb-3 ml-2" }, [
                    _vm._v(
                      " Relevant crates in progress : " +
                        _vm._s(_vm.selectedData.length) +
                        " "
                    ),
                  ]),
                  _c(
                    "b-table",
                    {
                      attrs: {
                        data: _vm.selectedData,
                        paginated: "",
                        "per-page": _vm.perPage,
                        "mobile-cards": "",
                        hoverable: "",
                        "row-class": (row, index) => "is-clickable",
                      },
                      on: { click: _vm.clickRow },
                    },
                    [
                      _c("b-table-column", {
                        attrs: {
                          field: "barcode",
                          label: "Barcode",
                          searchable: "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "searchable",
                              fn: function (props) {
                                return [
                                  _c("b-input", {
                                    attrs: {
                                      placeholder: "Search barcode...",
                                      size: "is-small",
                                    },
                                    model: {
                                      value: props.filters[props.column.field],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          props.filters,
                                          props.column.field,
                                          $$v
                                        )
                                      },
                                      expression:
                                        "props.filters[props.column.field]",
                                    },
                                  }),
                                ]
                              },
                            },
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _vm._v(" " + _vm._s(props.row.barcode) + " "),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3480061224
                        ),
                      }),
                      _c("b-table-column", {
                        attrs: {
                          field: "lastSeenBattery",
                          label: "Battery",
                          centered: "",
                          sortable: "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c(
                                    "span",
                                    [
                                      props.row.lastSeenBattery
                                        ? _c("b-icon", {
                                            staticClass: "mr-1",
                                            attrs: {
                                              pack: "fas",
                                              icon:
                                                props.row.lastSeenBattery > 90
                                                  ? "battery-full"
                                                  : props.row.lastSeenBattery >
                                                    70
                                                  ? "battery-three-quarters"
                                                  : props.row.lastSeenBattery >
                                                    50
                                                  ? "battery-half"
                                                  : props.row.lastSeenBattery >
                                                    20
                                                  ? "battery-quarter"
                                                  : "battery-empty",
                                              size: "is-small",
                                              type:
                                                props.row.lastSeenBattery === 0
                                                  ? "is-danger"
                                                  : "",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            props.row.lastSeenBattery
                                              ? props.row.lastSeenBattery + "%"
                                              : "Unknown"
                                          )
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          165265060
                        ),
                      }),
                      _c("b-table-column", {
                        attrs: {
                          field: "timestamp",
                          label: "Timestamp",
                          sortable: "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        new Date(
                                          props.row.timestamp
                                        ).toLocaleString()
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1850643667
                        ),
                      }),
                      _c("b-table-column", {
                        attrs: { label: "Status" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c(
                                    "span",
                                    [
                                      _c("b-icon", {
                                        staticClass: "mr-1",
                                        attrs: {
                                          pack: "fas",
                                          icon: "circle",
                                          size: "is-small",
                                          type:
                                            props.row.locationMethod === "sc"
                                              ? "is-primary"
                                              : "is-info",
                                        },
                                      }),
                                      _vm._v(
                                        " " + _vm._s(_vm.getStatus(props.row))
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1944467196
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "modal-card-head" }, [
      _c("p", { staticClass: "modal-card-title" }, [
        _vm._v(" All references "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }